<template>
  <div class="navbar">
    <ul class="app-nav-list pl-0">
      <li class="app-nav-item" v-for="(menuItem , key) in menuSection.Menu_List" :key="key">
        <router-link
          v-if="menuItem.Children_List && menuItem.Children_List.length"
          to
        >{{(menuItem.Title)}}</router-link>
        <router-link v-else :to="menuItem.Path">{{(menuItem.Title)}}</router-link>
        <template v-if="menuItem.Type === 'sub_menu'">
          <ul class="sub-menu" v-if="menuItem.Children_List && menuItem.Children_List.length > 0">
            <li v-for="(subMenuItem , subMenuKey) in menuItem.Children_List" :key="subMenuKey">
              <router-link
                :to="subMenuItem.Path"
                :class="[ subMenuItem.Type === 'sub_menu' ? 'menu-item-has-children':'']"
              >{{(subMenuItem.Title)}}</router-link>
              <ul class="sub-menu" v-if="subMenuItem.Children_List">
                <li
                  v-for="(childrenItem , childrenKey) in subMenuItem.Children_List"
                  :key="childrenKey"
                >
                  <router-link :to="childrenItem.Path">{{(childrenItem.Title)}}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </template>
        <template v-if="menuItem.Type === 'mega_menu'">
          <ul class="sub-menu mega">
            <li v-for="(megaitem,megaitemkey) in menuItem.Children_List" :key="megaitemkey">
              <!-- <a :href="megaitem.Path+'/?category='+megaitem.Category_ID">
              {{(megaitem.Title)}}-->
              <router-link
                :to="{name: 'Products',  query: {category: megaitem.Category_ID}}"
              >{{(megaitem.Title)}}</router-link>
              <!-- </a> -->
              <ul class="sub-menu">
                <li v-for="(submega,submegakey) in megaitem.Children_List" :key="submegakey">
                  <router-link
                    :to="{name: 'Products', query: {category: megaitem.Category_ID, subcategory: submega.Category_ID}}"
                  >{{(submega.Title)}}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../../services/utils/cms-helper";
export default {
  computed: {
    ...mapGetters(["selectedLocale"]),
  },
  data() {
    return {
      cmsRequestFunctions: null,
      menuSection: "",
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
  },
  watch: {
    selectedLocale: function () {
      this.getPageData();
    },
  },
  methods: {
    getPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "02 Header/02 Header/02 Header.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var menuArea = self.cmsRequestFunctions.pluck(
              "Menu_Section",
              res.area_List
            );
            self.menuSection = self.cmsRequestFunctions.getAllMapData(
              menuArea[0].component
            );
            self.$store.dispatch("setMenu", self.menuSection.Menu_List);
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>

